if (!customElements.get('splide-carousel')) {
  customElements.define(
    'splide-carousel',
    class SplideCarousel extends HTMLElement {
      constructor() {
        super()
        this.carousel = null
        this.nextArrow = null
        this.prevArrow = null
        this.splideId = this.getAttribute('data-splide-id')
        this.config = JSON.parse(this.getAttribute('data-splide'))
        this.mountCarousel()
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (document.querySelector(`[data-block-id="${e.detail.blockId}"][data-splide-id="${this.splideId}"]`)) {
              this.carousel.go(parseInt(e.target.dataset.slideIndex))
              this.carousel.Components.Autoplay.pause()
            }
          })
          document.addEventListener('shopify:section:deselect', (e) => {
            if (document.querySelector('[data-section-id="' + e.detail.sectionId + '"]')) {
              if (this.config.autoplay != undefined) {
                this.carousel.go(0)
                this.carousel.Components.Autoplay.play()
              }
            }
          })
          document.addEventListener('shopify:section:load', (e) => {
            const { sectionId } = e.detail
            const hasElement = e.target.id.indexOf(sectionId) != -1
            // reload product recommendations after switching settings
            if (e.target.querySelector(`[data-section-type="product-recommendations"]`) && hasElement) {
              this.carousel.destroy()
              this.mountCarousel()
            }
          })
        }
      }
      mountCarousel() {
        this.carousel = new Splide(this)
        this.carousel.mount()
        this.nextArrow = document.querySelector(`[data-splide-next][data-splide-id="${this.splideId}"]`)
        this.prevArrow = document.querySelector(`[data-splide-prev][data-splide-id="${this.splideId}"]`)

        if (this.nextArrow != null && this.prevArrow != null) {
          this.bindArrowActions()
        } else {
          // Updating default arrow SVGs to be ADA compliant
          //    Fixes: 1.1.1: Non-text Content – SVG element without alternative
          document.querySelector(`[data-splide-id="${this.splideId}"] button.splide__arrow--next svg`).ariaHidden = 'true'
          document.querySelector(`[data-splide-id="${this.splideId}"] button.splide__arrow--prev svg`).ariaHidden = 'true'
        }
      }
      bindArrowActions() {
        this.nextArrow.addEventListener('click', this.moveCarousel.bind(this))
        this.prevArrow.addEventListener('click', this.moveCarousel.bind(this))
      }
      moveCarousel(e) {
        let next = e.currentTarget.classList.contains('nextArrow') ? true : false
        if (next) {
          let slides = this.querySelectorAll('.splide__slide')
          let lastSlide = slides[slides.length - 1]
          if (this.config.type != undefined || this.config.rewind != undefined) {
            this.carousel.go('>')
          } else if (this.config.type == undefined && !lastSlide.classList.contains('is-visible')) {
            this.carousel.go('>')
          }
        } else {
          this.carousel.go('<')
        }
      }
    }
  )
}
